import React from 'react';
import styled, { keyframes } from 'styled-components';

const Wrapper = styled.div`
  z-index: 101;
  position: absolute;
  width: 48px;
  height: 48px;
  top: calc(50vh - 24px);
  left: calc(50vw - 24px);
`;

const keyframeSpin = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0);
  border: 8px solid rgba(255, 255, 255, 0.3);
  border-top-color: rgba(0, 0, 0, 0);

  animation: ${keyframeSpin} 1s linear infinite;
`;

export default () => (
  <Wrapper>
    <Spinner data-testid="shared__data-loading-spinner" />
  </Wrapper>
);
